import { render, staticRenderFns } from "./EditRecipeModal.vue?vue&type=template&id=3ec4848d&scoped=true&"
import script from "./EditRecipeModal.vue?vue&type=script&lang=js&"
export * from "./EditRecipeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditRecipeModal.vue?vue&type=style&index=0&id=3ec4848d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4848d",
  null
  
)

export default component.exports